import { render, staticRenderFns } from "./inspectionInformation.vue?vue&type=template&id=27f52050&scoped=true&"
import script from "./inspectionInformation.vue?vue&type=script&lang=js&"
export * from "./inspectionInformation.vue?vue&type=script&lang=js&"
import style0 from "./inspectionInformation.vue?vue&type=style&index=0&id=27f52050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f52050",
  null
  
)

export default component.exports